import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAdminAuth, formatApiError } from "@/context/AdminAuthContext";
import { LOGO } from "@/data/images";
import { Field, Input, Btn } from "@/admin/ui";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-forestdeep grain relative flex items-center justify-center px-4">
      <form onSubmit={submit} className="relative w-full max-w-sm bg-cream rounded-3xl p-8 shadow-2xl">
        <div className="flex justify-center"><img src={LOGO} alt="Nutribest" className="h-12 w-auto mix-blend-multiply" /></div>
        <div className="flex items-center justify-center gap-2 mt-5 text-forest">
          <Lock size={14} className="text-gold" />
          <h1 className="font-serif text-2xl">Admin Sign In</h1>
        </div>
        <div className="space-y-4 mt-7">
          <Field label="Email">
            <Input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@nutribest.com" />
          </Field>
          <Field label="Password">
            <Input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </Field>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-xs text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{error}</p>}
        <Btn data-testid="admin-login-submit" type="submit" busy={busy} className="w-full mt-6 py-3.5">Sign In</Btn>
        <a href="/" className="block text-center text-[11px] text-mutedgreen mt-5 hover:text-forest">← Back to website</a>
      </form>
    </div>
  );
}
